import Loader from 'bharat-ui/web/Loader';
import { makeStyles } from 'bharat-ui/web/Styles';
import React, { useEffect, useState } from 'react';
import { triggerJuspayPaymentModesApi, JuspayPaymentModesSlice, useJuspayPaymentModes } from 'Slices';
import { useDispatch } from 'react-redux';
import { showPostPeUI, showTwelvePcUI, showZillionUi } from 'utils/Utils';
import LoaderNew from 'components/atoms/Loader';
import Toasty from 'components/atoms/Toasty';
import { getURLParameter, removePostpeLoader, showPostpeLoader } from 'utils/nativeSupport';
import { registerSlice } from 'store';
import { useHistory, useParams } from 'react-router-dom';
import { globalId } from 'index';
import { CancelPaymentApi } from 'Services';
import { NativeSupportHandlerV2 } from 'native-support-handler';

registerSlice(JuspayPaymentModesSlice);

const useStyle = makeStyles(() => ({
	mainContainer: {
		background: '#ffffff',
		height: '100vh',
	},
}));

declare global {
	interface Window {
		callbackHyperSdkInit: any;
		callbackHyperSdkPaymentSuccess: any;
		callbackHyperSdkPaymentError: any;
		callbackHyperSdkInitStatus: any;
	}
}

const JuspayLandingPage: React.FC = () => {
	const isShowTwelvePcUI = showTwelvePcUI();
	const isShowPostPeUI = showPostPeUI();
	const isShowZillionUi = showZillionUi();
	const classes = useStyle();
	const dispatch = useDispatch();
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const juspayPaymentModesData = useJuspayPaymentModes();
	const checkout = getURLParameter(window.location.href, 'checkout') || '';
	const deviceTypeWeb = getURLParameter(window.location.href, 'deviceType') || '';
	const params: any = useParams();

	useEffect(() => {
		if (params?.pageSource === 'consumer') {
			dispatch(triggerJuspayPaymentModesApi({ checkout }));
		}
	}, [params]);

	useEffect(() => {
		if (juspayPaymentModesData?.data?.payloads?.initiate) {
			if (isShowPostPeUI)
				showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
			checkSdkInitialisationStatus(juspayPaymentModesData?.data?.payloads);
		}
	}, [juspayPaymentModesData?.data?.payloads, isShowPostPeUI, dispatch]);

	// useEffect(() => {
	// 	setLoading(false);
	// }, [juspayPaymentModesData.error.length > 1 && !juspayPaymentModesData.loading]);

	const checkSdkInitialisationStatus = async (juspayPayload: any) => {
		const nativeData = {
			key: 103,
		};

		console.log('===================callbackHyperSdkInitStatus payload======================');

		await window.androidObj.nativeSupport(JSON.stringify(nativeData));

		window.callbackHyperSdkInitStatus = (status: number) => {
			// 1: inprogress, 0: uninitialized, 2: initialized
			console.log('===================callbackHyperSdkInitStatus callback======================', status);
			if (Number(status) === 2) {
				processJuspayPayment(juspayPayload);
				return;
			}
			initialiseJuspayTransaction(juspayPayload);
		};
	};

	const initialiseJuspayTransaction = async (juspayPayload: any) => {
		const parsedPayload = JSON.parse(juspayPayload?.initiate);

		const nativeData = {
			key: 101,
			payload: parsedPayload,
		};

		console.log('===================callbackHyperSdkInit status payload======================');

		await window.androidObj.nativeSupport(JSON.stringify(nativeData));

		window.callbackHyperSdkInit = (status: number) => {
			// 1: inprogress, 0: uninitialized, 2: initialized
			console.log('===================callbackHyperSdkInit status callback======================', status);
			if (Number(status) === 2) {
				processJuspayPayment(juspayPayload);
				return;
			}
			const errorMsg = Number(status) === 1 ? 'Payment initialisation is in progress' : 'SDK is uninitialized';
			Toasty.error(errorMsg);
		};
	};

	const processJuspayPayment = async (juspayPayload: any) => {
		const parsedExternalPgPayload = JSON.parse(juspayPayload?.process);
		const parsedDeeplink = juspayPayload?.microViewDeepLink;
		const nativeData = {
			key: 102,
			payload: parsedExternalPgPayload,
			deeplink: parsedDeeplink,
		};
		console.log('===================callbackHyperSdkPaymentSuccess payload======================');
		await window.androidObj.nativeSupport(JSON.stringify(nativeData));

		window.callbackHyperSdkPaymentSuccess = (jsonString: any) => {
			console.log('===================callbackHyperSdkPaymentSuccess status======================', jsonString);
			history.push('/thanks');
		};

		window.callbackHyperSdkPaymentError = (jsonString: any) => {
			//redirect here
			console.log('===================callbackHyperSdkPaymentError status======================', jsonString);
			if (jsonString?.payload?.status === 'backpressed') {
				TriggerCancelPaymentApi();
				return;
			}
			history.push('/thanks');
		};
	};

	const redirectToSource = () => {
		if (juspayPaymentModesData?.data?.transaction?.redirectURI && deviceTypeWeb === 'web') {
			window.open(juspayPaymentModesData?.data?.transaction?.redirectURI, '_top');
			return;
		}
		NativeSupportHandlerV2.openDeeplink(juspayPaymentModesData?.data?.transaction?.redirectURIDeeplink);
	};

	const TriggerCancelPaymentApi = () => {
		setLoading(true);
		CancelPaymentApi({ txnId: globalId })
			.then((resp: any) => {
				redirectToSource();
			})
			.catch((err) => {
				redirectToSource();
			});
	};

	useEffect(() => {
		if (!isShowPostPeUI) return;

		showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
	}, [isShowPostPeUI]);

	return (
		<div className={isShowTwelvePcUI || isShowPostPeUI ? classes.mainContainer : ''}>
			{!isShowPostPeUI &&
				(isShowTwelvePcUI || isShowZillionUi ? (
					<LoaderNew loading={loading} loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
				) : (
					<Loader loading={loading} />
				))}
		</div>
	);
};

export default JuspayLandingPage;
